export default [
	{ id: '1', imageName: 'gallery/img1.jpg', tag: 'TEDX' },
	{ id: '2', imageName: 'gallery/img2.jpg', tag: 'IPR' },
	{ id: '3', imageName: 'gallery/img3.jpg', tag: 'IPR' },
	{ id: '4', imageName: 'gallery/img4.jpg', tag: 'pro' },
	{ id: '5', imageName: 'gallery/img5.jpg', tag: 'MEET' },
	{ id: '6', imageName: 'gallery/img6.jpg', tag: 'IPR' },
	{ id: '7', imageName: 'gallery/img6.jpg', tag: 'TEDX' },
	{ id: '8', imageName: 'gallery/img8.jpg', tag: 'TEDX' },
	{ id: '9', imageName: 'gallery/img9.jpg', tag: 'IPR' },
	{ id: '10', imageName: 'gallery/img10.jpg', tag: 'MEET' },
	{ id: '11', imageName: 'gallery/img11.jpg', tag: 'TEDX' },
	{ id: '12', imageName: 'gallery/img12.jpg', tag: 'MEET' },
	{ id: '13', imageName: 'gallery/img13.jpg', tag: 'MEET' },
	{ id: '14', imageName: 'gallery/img14.jpg', tag: 'TEDX' },
	
];
